import { render } from "./MpkEventTypeCard.vue?vue&type=template&id=5b200bd2"
import script from "./MpkEventTypeCard.vue?vue&type=script&lang=js"
export * from "./MpkEventTypeCard.vue?vue&type=script&lang=js"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__